import { createAsyncThunk } from "@reduxjs/toolkit";
import { orderErrorToast, orderSuccessToast } from "../../../../app/funcs/orderResultToast";
import { CareCommentId } from "../../../../domain/care_comment/CareCommentId";
import { deleteCareComment, registerCareComment, RegisterCareCommentRequestType, updateCareComment, UpdateCareCommentRequestType } from "./api";

export const ActionType = Object.freeze({
    base: "@@Monitoring/Action/Admin/CareComment",
    register: "register",
    update: "update",
    delete: "delete",
});

export const registerCareCommentAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.register}`,
    async (data: {
        requestData: RegisterCareCommentRequestType
    }, { rejectWithValue }) => {
        const response = await registerCareComment(data.requestData);

        if (response.error === undefined) {
            orderSuccessToast("ケアコメントを登録しました。");
            return { carecomment: { ...response, threadId: data.requestData.threadId?.value, isRead: false, isPinned: false } };
        } else {
            // API処理結果異常の場合
            orderErrorToast("ケアコメントの登録に失敗しました");
            return rejectWithValue({});
        }
    }
);

export const updateCareCommentAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.update}`,
    async (data: {
        requestData: UpdateCareCommentRequestType
    }, { rejectWithValue }) => {
        const response = await updateCareComment(data.requestData);

        if (response.error === undefined) {
            orderSuccessToast("ケアコメントを更新しました。");
            return { carecomment: { ...response } };
        } else {
            // API処理結果異常の場合
            orderErrorToast("ケアコメントの登録に失敗しました");
            return rejectWithValue({});
        }
    }
);

export const deleteCareCommentAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.delete}`,
    async (data: {
        careCommentId: CareCommentId
    }, { rejectWithValue }) => {
        const response = await deleteCareComment(data.careCommentId);

        if (response.error === undefined) {
            orderSuccessToast("ケアコメントを削除しました。");
            return { careCommentId: data.careCommentId.value };
        } else {
            // API処理結果異常の場合
            orderErrorToast("ケアコメントの削除に失敗しました");
            return rejectWithValue({});
        }
    }
);